
import React from 'react';
import PropTypes from 'prop-types';
import css from './styles/EgSpinner.scss'; // cra
import { Spinner } from 'react-bootstrap';

export default function EgSpinner(props) {
    return (
        <Spinner 
            animation="border" 
            variant="primary"
            className="d-block mx-auto"
        />
    );
}
EgSpinner.propTypes = {};
    